import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	createProductReviewThunk,
	fetchDigitalProductDetailsThunk,
	fetchDigitalProductsThunk,
	fetchLandingPageCategoriesThunk,
	fetchLandingPageNonDigitalCategoriesThunk,
	fetchNonDigitalProductDetailsThunk,
	fetchProductDetailsThunk,
	fetchProductsByCategoryThunk,
	frequestlyBroughtTogetherProductThunk,
	getAllCategoriesThunk,
	getPerticularProductAllReviewsThunk,
	getUserProductReviewThunk,
	updateProductLikeAndDislikeCountThunk,
	updateProductReviewThunk,
} from './landingPageApis'

const initialState = {
	categories: [],
	subCategories: [],
	childCategories: [],
	allCategories: [],

	nonDigitalCategories: [],
	digitalProducts: [],
	categoryProducts: [],
	productDetails: null,
	digitalProductDetails: null,
	nonDigitalProductDetails: null,
	frequestlyBroughtTogetherProducts: [],
	productReviews: [],
	ratingDetails: { averageRating: 0, totalCount: 0, totalRating: 0 },
	ratingsBreakdown: [],
	productReview: {},
}

export const getLandingPageCategoriesData = createAsyncThunk('/getLandingPageCategoriesData', fetchLandingPageCategoriesThunk)

export const getLandingPageSubCategoriesData = createAsyncThunk('/getLandingPageSubCategoriesData', fetchLandingPageCategoriesThunk)
export const getLandingPageChildCategoriesData = createAsyncThunk('/getLandingPageChildCategoriesData', fetchLandingPageCategoriesThunk)

export const getLandingPageNonDigitalCategoriesData = createAsyncThunk(
	'/getLandingPageNonDigitalCategoriesData',
	fetchLandingPageNonDigitalCategoriesThunk
)

export const getDigitalProductsData = createAsyncThunk('/getDigitalProductsData', fetchDigitalProductsThunk)

export const getProductsByCategoryData = createAsyncThunk('/getProductsByCategoryData', async (id) => {
	return await fetchProductsByCategoryThunk(id)
})

export const getAllCategories = createAsyncThunk('/getAllCategories', getAllCategoriesThunk)

// Create async thunk for fetching product details
export const fetchProductDetails = createAsyncThunk('product/fetchProductDetails', fetchProductDetailsThunk)
export const fetchNonDigitalProductDetails = createAsyncThunk('product/fetchNonDigitalProductDetails', fetchNonDigitalProductDetailsThunk)
export const fetchDigitalProductDetails = createAsyncThunk('product/fetchDigitalProductDetailsThunk', fetchDigitalProductDetailsThunk)
export const frequestlyBroughtTogetherProduct = createAsyncThunk('product/frequestlyBroughtTogetherProduct', frequestlyBroughtTogetherProductThunk)
export const createProductReview = createAsyncThunk('product/createProductReview', createProductReviewThunk)
export const getUserProductReview = createAsyncThunk('product/getUserProductReview', getUserProductReviewThunk)
export const updateProductReview = createAsyncThunk('product/updateProductReview', updateProductReviewThunk)
export const getPerticularProductAllReviews = createAsyncThunk('product/getPerticularProductAllReviews', getPerticularProductAllReviewsThunk)
export const updateProductLikeAndDislikeCount = createAsyncThunk('product/updateProductLikeAndDislikeCount', updateProductLikeAndDislikeCountThunk)

export const landingPageSlice = createSlice({
	name: 'landingPage',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(frequestlyBroughtTogetherProduct.fulfilled, (state, action) => {
			state.frequestlyBroughtTogetherProducts = action.payload?.data
		})
		builder.addCase(getLandingPageCategoriesData.fulfilled, (state, action) => {
			state.categories = action.payload?.data
		})
		builder.addCase(fetchNonDigitalProductDetails.fulfilled, (state, action) => {
			state.nonDigitalProductDetails = action.payload?.data
		})
		builder.addCase(fetchDigitalProductDetails.fulfilled, (state, action) => {
			state.digitalProductDetails = action.payload?.data
		})
		builder.addCase(getLandingPageSubCategoriesData.fulfilled, (state, action) => {
			state.subCategories = action.payload?.data
		})
		builder.addCase(getLandingPageChildCategoriesData.fulfilled, (state, action) => {
			state.childCategories = action.payload?.data
		})
		builder.addCase(getAllCategories.fulfilled, (state, action) => {
			state.allCategories = action.payload?.data
		})
		builder.addCase(getLandingPageNonDigitalCategoriesData.fulfilled, (state, action) => {
			state.nonDigitalCategories = action.payload?.data
		})
		builder.addCase(getDigitalProductsData.fulfilled, (state, action) => {
			state.digitalProducts = action.payload?.data
		})
		builder
			.addCase(getProductsByCategoryData.fulfilled, (state, action) => {
				state.categoryProducts = action.payload?.data
			})
			.addCase(fetchProductDetails.fulfilled, (state, action) => {
				state.productDetails = action.payload?.data
			})
		builder.addCase(getPerticularProductAllReviews.fulfilled, (state, action) => {
			state.productReviews = action.payload?.data
			state.ratingDetails = action.payload?.ratingDetails
			state.ratingsBreakdown = action.payload?.ratingsBreakdown
		})
		builder.addCase(getUserProductReview.fulfilled, (state, action) => {
			state.productReview = action.payload?.data
		})
	},
})
// export const {} = teamsSlice.actions
export default landingPageSlice.reducer
